import { Loader } from "../index";
import { Typography } from "@corecomponents/ui";

const LoadingSection = ({
  color = "#5a4bda",
  message = "",
  scale = 3,
}: {
  color?: string;
  message?: string;
  scale?: number;
}) => {
  return (
    <div
      className={
        "w-full h-full space-y-3 p-2 flex-col flex justify-center items-center animated fadeIn duration-200"
      }
    >
      <Loader color={color} scale={scale} />
      {message && (
        <Typography key={"loading-message"} variant={"heading2"} weight={600}>
          {message}
        </Typography>
      )}
    </div>
  );
};

export default LoadingSection;
